module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "home"
    }
  }, [_c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox,
      "transparent": true,
      "extended": true
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "h2 medium c-dark"
  }, [_c('span', {
    staticClass: "upcase"
  }, [_vm._v(_vm._s(_vm.configurator == 'k1_wall' ? 'k1' : _vm.configurator))]), _vm._v("\n        Configurator\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "nlbr",
      rawName: "v-nlbr",
      value: (_vm.$t((_vm.configurator + "_start_text"))),
      expression: "$t(`${configurator}_start_text`)"
    }],
    staticClass: "h3 light c-dark"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "home_inputs-container"
  }, [_c('span', {
    staticClass: "medium h6 c-dark"
  }, [_vm._v(_vm._s(_vm.$t('misure')))]), _vm._v(" "), _c('input-text', {
    attrs: {
      "value": _vm.room_size.width,
      "placeholder": "0",
      "label": _vm.$t('width'),
      "error": _vm.$t('width_error'),
      "errorcallback": _vm.checkWidth,
      "info": "CM"
    },
    on: {
      "input": _vm.changeRoomWidth,
      "focus": _vm.checkRoomUprights
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "value": _vm.room_size.height,
      "placeholder": "0",
      "label": _vm.$t('height'),
      "error": [_vm.$t('height_error'), _vm.$t((_vm.configurator + "_height_max_error"))],
      "errorcallback": [_vm.checkHeight, _vm.checkUpper],
      "info": "CM"
    },
    on: {
      "input": _vm.changeRoomHeight,
      "focus": _vm.checkRoomUprights
    }
  })], 1), _vm._v(" "), (_vm.configurator === 'k1') ? _c('div', {
    ref: "alignment",
    staticClass: "k1_alignment"
  }, [_c('check-element', {
    attrs: {
      "label": _vm.$t('alignment'),
      "invert": true,
      "imagebig": true,
      "imageheight": "51px",
      "initialvalue": !_vm.isAlignedTop,
      "trueimage": "/images/alignment.svg",
      "falseimage": "/images/alignment-invert.svg"
    },
    on: {
      "change": _vm.toggleAlignment
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b04c370"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Home.vue
// module id = 637
// module chunks = 0